<script type="text/jsx">
import _ from 'lodash';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover.vue';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';
import { trackingPlanTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import { mapMutations } from 'vuex';
import LicenseTip from '@/plans/ZOOM_MEETING/license-tip.vue';

export default {
  components: { LicenseTip, InputNumberWithPopover },
  props: {
    region: {
      type: String,
      default: PBX_REGIONS.US_AND_CANADA,
    },
    planUnit: {
      type: Number,
      default: planUnitMap.user,
      validator(value) {
        return Object.values(planUnitMap).includes(value);
      },
    },
    licenseTips: String,
    maxHosts: {
      type: Number,
      default: 99,
    },
    minHosts: {
      type: Number,
      default: 1,
    },
    decreaseTips: String,
    getIncreaseTips: {
      type: Function,
      default: _.noop,
    },
    billingCycle: String,
    planList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      license: 1,
    };
  },
  computed: {
    trackingPlanKey() {
      return trackingPlanTypes.ZONE_PRO_PLUS;
    },
    currentSelectedPlan() {
      return plansof(this.planList).cycle(this.billingCycle).get(0);
    },
    additionalSpans() {
      return {
        proplus: [
          {
            value: 1,
            text: '',
          },
          {
            value: this.maxHosts,
            text: this.$t('billing.zone.max_of_plans_user', [this.maxHosts, this.maxHosts + 1]),
          },
        ],
      }
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    updateCart(newLicense, oldLicense) {
      const planCode = this.currentSelectedPlan?.plan_code;

      if (planCode) {
        this.updateSelectPlan({
          plan_code: planCode,
          cartInfo: { selected_number: newLicense },
        });
      }

      // event tracking
      planCode && this.$tracking.addOnBuyInteraction(`${this.trackingPlanKey} license`,
        `${this.trackingPlanKey} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
    },
    changeLicense(newLicense) {
      const oldLicense = this.license;
      this.license = newLicense;
      this.updateShoppingCart(newLicense, oldLicense);
    },
    toggleLicenseTips(tips) {
      tips && this.$tracking.addOnBuyInteraction(`${this.trackingPlanKey} options`, 'licenses - tooltip');
    },
    handleLicenseTipsClick(e) {
      if(e?.target?.tagName === 'A') {
        this.$tracking.buyInteraction(`${this.trackingPlanKey} plan users`, 'the maximum amount is 99 users - contact sales');
      }
    },
    mx_renderLicense() {
      const planUnit = getPlanUnitWithQuantity(this.planUnit);

      return <div class="opc-bundle-config-row__input__number">
        <license-tip class="opc-bundle-config-row__alert" type="proplus" number={this.license} additionalSpans={this.additionalSpans} onClick={this.handleLicenseTipsClick} />
        <input-number-with-popover
          value={this.license}
          onChange={this.changeLicense}
          size="large"
          controls-position="both"
          min={this.minHosts}
          max={this.maxHosts}
          increaseTips={this.getIncreaseTips(this.selectCapacity, this.license)}
          decreaseTips={this.decreaseTips}
          unit={this.inputUnit}
          label={`${this.trackingPlanKey} + ' Select the number of ${planUnit}'`}
        />
        {(this.$slots.licenseTips || !this.licenseTips) ?
          this.$slots.licenseTips :
          <zm-tooltip
            class="opc-bundle-config-row__tooltips"
            role="button"
            aria-label="Learn more about Select the number of licenses"
            content={this.licenseTips}
            placement="bottom"
            onInput={this.toggleLicenseTips}>
            <i class="zm-icon-info-outline" />
          </zm-tooltip>}
      </div>;
    },
  },
  render() {
    return this.mx_renderLicense();
  },
  created() {
    if (this.currentSelectedPlan) {
      this.license = this.currentSelectedPlan.cartInfo?.selected_number;
    }

    // A closure (timeId) needs to be generated for each config row instance
    this.updateShoppingCart = _.debounce(this.updateCart, 200);
  },
};
</script>

<style lang="scss">
.opc-bundle-config-row {

  &__alert.is-warning {
    margin-bottom: 12px;
  }

  &__input__number {

  }
}
</style>
